import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';

import { EntreprisesFilters } from '../entities/entreprises-filters.entity';

@Component({
	selector: 'entreprises-filters',
	templateUrl: 'entreprises-filters.html',
	styleUrls: ['entreprises-filters.css']
})
export class EntreprisesFiltersComponent implements AfterViewInit {
	// Valeurs des filtres choisis par l'utilisateur
	filters: EntreprisesFilters = new EntreprisesFilters();

	// Evenement pour quand l'utilisateur demande l'application des filtres
	@Output() filterRequest = new EventEmitter<EntreprisesFilters>();

	ngAfterViewInit() {
		this.applyFilters();
	}

	applyFilters() {
		this.filterRequest.emit(this.filters);
	}

	resetFilters() {
		this.filters = new EntreprisesFilters();
		this.applyFilters();
	}
}